<template>
    <div class="checkbox" ref="checkboxContainer"
         v-bind:class="{'checkbox--focused': focused, 'checkbox--disabled': disabled}">
        <input type="checkbox" :checked="value" :id="name" :name="name" @change="onChange" @focus="onFocus"
               @blur="onBlur" :disabled="disabled">
        <label :for="name">
            {{ label }}
            <slot></slot>
        </label>
        <input-error v-if="v" :v="v" :name="name" @o3-error="error = $event"></input-error>
    </div>
</template>

<script>
import InputMixin from './mixin';

export default {
    mixins:  [InputMixin],
    data() {
        return {
            checked: this.value,
        }
    },
    methods: {
        onChange(e) {
            this.$emit('input', e.target.checked);
            this.$emit('change', e);
        },
        successHighlight() {
            const element = this.$refs.checkboxContainer;
            element.classList.add('success-highlight');
            setTimeout(() => element.classList.remove('success-highlight'), 1000);
        },
    }
}
</script>
